// extracted by mini-css-extract-plugin
module.exports = {"ruleEditorWrapper":"ruleEditorWrapper","ruleEditorWrapperAffixed":"ruleEditorWrapperAffixed"};